import React from "react";
import { Box, Typography, Card, CardContent, Chip, Stack } from "@mui/material";
import CustomButton from "../shared/CustomButton";

const ALL_COLORS = [
  "#b9d3fa",
  "#fabdb9",
  "#b9fabd",
  "#faf2b9",
  "#fab9c4",
  "#c1b9fa",
  "#f6fab9",
  "#b9d3fa",
  "#fabdb9",
  "#b9fabd",
];

const AboutMe = () => {
  const edudata = [
    {
      college: "IIT Jodhpur",
      stream: "Mechanical Engineering",
      year: "Expected May 2023",
      cgpa: "8.33",
    },
    {
      college: "Sri Chaitanya College",
      stream: "Maths, Physics, Chemistry",
      year: "May 2019",
      cgpa: "9.94",
    },
    {
      college: "JNV Vizianagaram",
      stream: "",
      year: "May 2017",
      cgpa: "10",
    },
  ];

  const skills = [
    "React.js",
    "Next.js",
    "Django",
    "AWS",
    "Material-UI",
    "JavaScript",
    "Python",
    "Node.js",
  ];
  return (
    <Box
      sx={{ flexGrow: 1, backgroundColor: "transparent" }}
      className="text-white"
    >
      {/* About Me Section */}
      <Box className="mb-8">
        <CustomButton>
          <Typography variant="h6" sx={{ fontFamily: "Crimson Text, serif" }}>
            About Me{" "}
          </Typography>
        </CustomButton>
        <div className="bg-gray-700 p-4 mt-4 rounded-lg">
          <p className="font-sans text-lg">
            I'm a dedicated software developer with a passion for building
            user-friendly applications. My journey started with a love for
            technology and has grown into a career in full-stack development,
            where I thrive in solving complex problems and creating efficient
            solutions.
          </p>
        </div>
      </Box>

      {/* Education Section */}
      <Box className="mb-8">
        <CustomButton>
          <Typography variant="h6" sx={{ fontFamily: "Crimson Text, serif" }}>
            Education{" "}
          </Typography>
        </CustomButton>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {edudata.map((edu, index) => (
            <Box
              key={index}
              className="bg-gray-700 p-4 mt-4 rounded-lg transform transition-transform hover:scale-105"
            >
              <Typography variant="h6" className="text-[#66FCF1]">
                {edu.college}
              </Typography>
              <Typography variant="body2" className="text-gray-400">
                {edu.stream}
              </Typography>
              <Box className="flex justify-between text-gray-400">
                <Typography variant="body2">{edu.year}</Typography>
                <Typography variant="body2">
                  CGPA: <span className="text-[#66FCF1]">{edu.cgpa}</span>
                </Typography>
              </Box>
            </Box>
          ))}
        </div>
      </Box>

      {/* Skills Section */}
      {/* <Box className="mb-8">
        <CustomButton>
          <Typography variant="h6" sx={{ fontFamily: "Crimson Text, serif" }}>
            Skills{" "}
          </Typography>
        </CustomButton>
        <Stack direction="row" className="mt-4 flex flex-wrap">
          {skills.map((skill, index) => (
            <Chip
              key={index}
              label={skill}
              className="mr-1 mt-1"
              style={{ backgroundColor: ALL_COLORS[index % ALL_COLORS.length] }}
            />
          ))}
        </Stack>
      </Box> */}

      {/* Positions of Responsibility Section */}
      <Box>
        <CustomButton>
          <Typography variant="h6" sx={{ fontFamily: "Crimson Text, serif" }}>
            Positions of Responsibility{" "}
          </Typography>
        </CustomButton>
        <div className="bg-gray-700 p-4 mt-4 rounded-lg">
          <ul className="list-disc ml-5">
            <li>
              Head | ATS | Varchas’2022 - Arranged accommodation and
              transportation for 900 students from outside colleges in Jodhpur
              City.
            </li>
            <li>
              Head | Braking | BAJA SAE 2021-22 - Led a team of 4 members to
              design and develop the braking system for an ATV.
            </li>
          </ul>
        </div>
      </Box>
    </Box>
  );
};

export default AboutMe;
